export default {
	type: 'object',
	properties: {
		channelId: {
			type: 'string',
		},
	},
	additionalProperties: false,
}
